import React from "react";
import img from "./kyc.png";
const KycShape = () => {
	return (
		<img src={img} alt="" />
		// <svg width={525} height={951} viewBox="0 0 525 951" fill="none">
		// 	<g filter="url(#filter0_f_27_1022)">
		// 		<path
		// 			d="M403.943 635.966C492.061 675.157 595.083 635.084 634.051 546.462C673.019 457.839 633.176 354.225 545.057 315.034C456.94 275.843 353.917 315.915 314.949 404.538C275.981 493.161 315.825 596.775 403.943 635.966Z"
		// 			fill="url(#paint0_radial_27_1022)"
		// 		/>
		// 	</g>
		// 	<defs>
		// 		<filter
		// 			id="filter0_f_27_1022"
		// 			x={0}
		// 			y={0}
		// 			width={949}
		// 			height={951}
		// 			filterUnits="userSpaceOnUse"
		// 			colorInterpolationFilters="sRGB"
		// 		>
		// 			<feFlood floodOpacity={0} result="BackgroundImageFix" />
		// 			<feBlend
		// 				mode="normal"
		// 				in="SourceGraphic"
		// 				in2="BackgroundImageFix"
		// 				result="shape"
		// 			/>
		// 			<feGaussianBlur
		// 				stdDeviation={150}
		// 				result="effect1_foregroundBlur_27_1022"
		// 			/>
		// 		</filter>
		// 		<radialGradient
		// 			id="paint0_radial_27_1022"
		// 			cx={0}
		// 			cy={0}
		// 			r={1}
		// 			gradientUnits="userSpaceOnUse"
		// 			gradientTransform="translate(813.003 690.288) rotate(-154.311) scale(807.103 735.532)"
		// 		>
		// 			<stop offset="0.34394" stopColor="#00EBFF" />
		// 			<stop offset="0.619147" stopColor="#FF39B0" />
		// 			<stop offset="0.974236" stopColor="#161C1B" />
		// 		</radialGradient>
		// 	</defs>
		// </svg>
	);
};

export default KycShape;
